import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c690e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "downloadModalLabel"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

import { ref, onMounted, onUnmounted } from 'vue';

import { Modal } from 'bootstrap';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadModal',
  setup(__props, { expose: __expose }) {

const downloadRef = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;


onMounted(() => {
    modalInstance = new Modal(downloadRef.value!, { keyboard: false });
});

onUnmounted(() => {
    modalInstance?.dispose();
});

const showModal = () => {

    modalInstance?.show();
};


const hideModal = () => {

    modalInstance?.hide();
};


__expose({ showModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    ref_key: "downloadRef",
    ref: downloadRef,
    tabindex: "-1",
    "aria-labelledby": "downloadModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("message.download_tip")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.windows_download_tip")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal",
            onClick: hideModal
          }, _toDisplayString(_ctx.$t("message.close")), 1)
        ])
      ])
    ])
  ], 512))
}
}

})